import {useQuery} from 'react-query'
import {RolePermissionEditModalForm} from './RolePermissionEditModalForm'
import {isNotEmpty, QUERIES} from '../../../../../_metronic/helpers'
import {useListView} from '../core/ListViewProvider'
import {getRolePermissionById} from '../core/_requests'

const RolePermissionEditModalFormWrapper = () => {
  const {itemIdForUpdate, setItemIdForUpdate} = useListView()
  const enabledQuery: boolean = isNotEmpty(itemIdForUpdate)

  const {isLoading, data: rolepermission, error} = useQuery(
    `${QUERIES.USERS_LIST}-rolepermission-${itemIdForUpdate}`,
    () => getRolePermissionById(itemIdForUpdate),
    {
      cacheTime: 0,
      enabled: enabledQuery,
      onError: (err) => {
        setItemIdForUpdate(undefined)
        console.error(err)
      },
    }
  )

  if (!itemIdForUpdate) {
    return <RolePermissionEditModalForm isRolePermissionLoading={isLoading} rolepermission={{id: undefined, name: '', permissions: []}} />
  }

  if (!isLoading && !error && rolepermission) {
    return <RolePermissionEditModalForm isRolePermissionLoading={isLoading} rolepermission={rolepermission} />
  }

  return null
}

export {RolePermissionEditModalFormWrapper}
